import {Component, Inject, OnInit} from '@angular/core';
import {MAT_DIALOG_DATA, MatDialogContent, MatDialogRef} from "@angular/material/dialog";
import {TierInterface} from "../../../interfaces/billing/tier.Interface";
import {ModalHeaderComponent} from '../../../layout/modal-header/modal-header.component';
import {CurrencyPipe, NgIf, UpperCasePipe} from '@angular/common';
import {FormsModule} from '@angular/forms';

@Component({
    selector: 'app-change-tier-confirmation',
    templateUrl: './change-tier-confirmation.component.html',
    styleUrls: ['./change-tier-confirmation.component.scss'],
  imports: [ModalHeaderComponent, MatDialogContent, NgIf, FormsModule, UpperCasePipe, CurrencyPipe]
})
export class ChangeTierConfirmationComponent implements OnInit {
  input = ''
  constructor(
    @Inject(MAT_DIALOG_DATA) public data: {
      tier: TierInterface,
      mode: 'upgrade' | 'downgrade',
      yearly: boolean,
    },
    public dialogRef: MatDialogRef<ChangeTierConfirmationComponent>
  ) {}

  yearlyPrice = 0

  ngOnInit(): void {
    this.yearlyPrice = Math.floor(this.data.tier.price * 0.8) * 12
  }

  confirm() {
    if (this.input.toUpperCase() === this.data.tier.name.toUpperCase()) {
      this.dialogRef.close(true)
    }
  }

}
